import { cva } from '@/styled-system/css';

export const progressRangeRecipe = cva({
  base: {
    position: 'absolute',
    zIndex: '2',
    insetBlock: 0,
    insetInlineStart: 0,
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'width 0.2s ease-in-out',
    },
  },
  variants: {
    size: {
      md: {
        borderRadius: 'obj.default',
      },
      sm: {
        borderRadius: 'shape.capsule',
      },
    },
    complete: {
      true: {
        backgroundColor: 'ProgressIndicator.bar.track.bg.complete',
      },
      false: {
        backgroundColor: 'ProgressIndicator.bar.track.bg.active',
      },
    },
  },
});
